import React, { useState, useEffect } from 'react';
import './Scheduler.css';

const Scheduler = ( {eventsArr} ) => {
    
    return (
        <div className="outer">
            <div className="main">

            </div>
        </div>
    );
};

export default Scheduler;